import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Grid, InputAdornment } from '@mui/material';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import React, { useEffect, useRef, useState } from 'react';
import {
    IValuationFormSection
} from '../../interfaces';
import { Format } from '../../utils';


export const ValuationFormSection: React.SFC<IValuationFormSection> = ({
    material,
    onUpdate,
    ...props
}: IValuationFormSection) => {

    const [valueActive, setValueActive] = useState(false);


    const activate = () => {
        setValueActive(true);

        if (!material.valueEstimate ?? 0 > 0) {
            let a = document.getElementById("me_id") as HTMLInputElement;
            a.select();
        }

    }

    useEffect(() => {

    }, [material, valueActive])

    return (
        <Accordion
            defaultExpanded={true}
        >
            <AccordionSummary
                expandIcon={<ExpandMore />}
            >
                <DialogContentText color="primary">
                    Valuation
                </DialogContentText>
            </AccordionSummary>
            <AccordionDetails>

                <Grid container>
                    <Grid item={true} xs={4} sx={{ p: 0.5 }}>
                        <TextField
                            id="me_id"
                            fullWidth
                            required
                            InputProps={{
                                startAdornment: <InputAdornment position="start" > £</InputAdornment>
                            }}
                            inputProps={{ min: 0.01, step: 'any' }}
                            variant="outlined"
                            type={valueActive ? "number" : "text"}
                            label="Value Estimate"
                            value={valueActive ? material.valueEstimate : Format.currency(material.valueEstimate)}
                            onChange={(e) => onUpdate("valueEstimate", e.currentTarget.value)}
                            onClick={() => activate()}
                            onBlur={() => setValueActive(false)}
                        />
                    </Grid>
                    <Grid item={true} xs={4} sx={{ p: 0.5 }}>
                        <TextField
                            fullWidth
                            required
                            InputProps={{ startAdornment: <InputAdornment position="start" > £</InputAdornment> }}
                            inputProps={{ min: 0.01, step: 'any' }}
                            variant="outlined"
                            type={valueActive ? "number" : "text"}
                            label="Total Value Estimate"
                            value={valueActive ? material.totalValueEstimate : Format.currency(material.totalValueEstimate)}
                            onChange={(e) => onUpdate("totalValueEstimate", e.currentTarget.value)}
                            helperText={"valuation of the total quantity (" + material.quantity + ")"}
                            onClick={() => setValueActive(true)}
                            onBlur={() => setValueActive(false)}
                            onFocus={e => e.target.select()}

                        />
                    </Grid>
                    <Grid item={true} xs={12} sx={{ p: 0.5 }}>
                        <TextField
                            fullWidth
                            multiline
                            rows={3}
                            variant="outlined"
                            label="Valuation Origin / Reasoning"
                            value={material.valuationOrigin}
                            onChange={(e) => onUpdate("valuationOrigin", e.currentTarget.value)}
                            helperText="Where and how was the valuation calculated"
                        />
                    </Grid>

                </Grid>

            </AccordionDetails>
        </Accordion>

    );
}